export const level0 = "00";
export const level5 = "0D";
export const level10 = "1B";
export const level15 = "28";
export const level20 = "34";
export const level25 = "40";
export const level30 = "4D";
export const level35 = "5A";
export const level40 = "66";
export const level45 = "73";
export const level50 = "80";
export const level55 = "8C";
export const level60 = "99";
export const level65 = "A6";
export const level70 = "B4";
export const level75 = "C0";
export const level80 = "CD";
export const level85 = "D9";
export const level90 = "E6";
export const level95 = "F3";
export const level100 = "FF";
